"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetDetailModalFooterContainer = exports.AssetDetailContent = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.AssetDetailContent = styled_components_1.default.div `
	max-width: 1000px;
	aspect-ratio: 16 / 9;
`;
exports.AssetDetailModalFooterContainer = styled_components_1.default.div `
	display: flex;
	justify-content: flex-end;
	flex-wrap: wrap;
	gap: 0.5rem 0;
`;
